import { toast } from '@/common/util'
import baseApi from './base.api'
import type { CommunicationsType } from '@/types/types'

const api = {
  ...baseApi,
  resource: 'Comunicacao',
  async getUserCommunication(params: Object): Promise<{data: CommunicationsType[], success: boolean}> {
    try {
      return await api.get('getAllPorUsuarioAutenticado', { ...params })
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0]})
    }
  },
  async changeUserCommunicationsStatus(ids: string[], showAgain: boolean): Promise<{data: boolean, success: boolean}> {
    try {
      return await api.post(`ChangeUserCommunicationStatus/${showAgain}`, ids)
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0]})
    }
  },
  async associationContracts(comunicacaoId: string, contratosComunicacoesIds: string[]): Promise<{ data: any[]; success: boolean }> {
    try {
      return await api.put(`${comunicacaoId}/UpdateContratosComunicacoes`, contratosComunicacoesIds)
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar vincular contratos a comunicação!' })
    }
  }
}

export default api
